// const { off } = require("gulp");

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    let offersTab = document.getElementsByClassName("js-offers");
    if (offersTab.length) {
        const offersTemplate = (special) => {
            let link = special.link.includes("https") ? special.link : offersTab[0].href + special.link;
            return `
                <li class="privary-navigation__item">
                    <a tabindex="-1" href="${link}">${special.name}</a>
                </li>
            `;
        }

        const req = new FormData();
        req.append('operation', 'getSpecialsTabs');
        req.set('site_id', site_id);

        fetch('ajax/functions.php', { method: 'POST', body: req })
        .then(resp => resp.json())
        .then(data => {
            data = data.map(eachOffer => offersTemplate(eachOffer)).join('');

            [...offersTab].forEach(offerTab => {
                let offerSubmenu = offerTab.parentElement.getElementsByClassName("submenu")[0];
                offerSubmenu && offerSubmenu.insertAdjacentHTML('beforeend', data);
            });
        })
    }

    //HOME ARROW
    $('.arrow-home').click(function(event) {
        $('body, html').animate({
            scrollTop: $('.hero-container').outerHeight()
        });
    });

    $('.accordion-btn').click(function(){
        $(this).toggleClass('active');
        $('.accordion-content').slideToggle();
    });


    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick();

    $('.gallery-landing__slider').slick({
        infinite: true,
        slidesToShow: 4,
        autoplay: true,
        autoplaySpeed: 4000,
        // slidesToScroll: 4,
        arrows : false,
        responsive: [
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                 autoplay: true,
                 autoplaySpeed: 4000,
              }
            },
          ]
    });


    $('h1, h2, h3, h4, h5, h6').addClass('title');
    $('h3, h4, h5, h6').addClass('title--subtitle');

    $('.intro-container .btn').addClass('btn--box');
    //$('.btn--arrow').wrapInner('<span class="btn--arrow__arrow"></span>');

    $('.special-event-container a').addClass('btn btn--box');

    //FANCYBOX
    $('.fancybox-copy').fancybox({
        wrapCSS : 'fancybox-copy-holder',
        maxWidth: 800
    });

    $('.expand-content').click(function() {
        event.preventDefault();
        $(this).closest('.container').next('.each-item__bottom').slideDown();
    });

    $('.closemore').click(function() {
        event.preventDefault();
        $(this).parent().slideUp();
    });



    //$('#home .dining-container a').addClass('btn btn--arrow');

    ////tabs sections
    const tabLinks = document.querySelectorAll('ul.tabs-menu li a');

    for (let i = 0; i < tabLinks.length; i++) {
        tabLinks[i].onclick = function() {
            let target = this.getAttribute('href').replace('#', '');
            let sections = document.querySelectorAll('div.tab-content');
            for(let j=0; j < sections.length; j++) {
                sections[j].style.display = 'none';
            }
            document.getElementById(target).style.display = 'block';
            for(let k=0; k < tabLinks.length; k++) {
                tabLinks[k].removeAttribute('class');
            }
            this.setAttribute('class', 'active');
            return false;
        }
    }

    $('.installation__item .title').click(function(){
        $(this).toggleClass('open');
        $(this).next('.installation__galleries').toggleClass('open').slideToggle();
    });

    const btnVideos = document.getElementsByClassName("btn-video");
    const videoTPL = src => `
        <div class="video-pop-up closed">
            <div class="video-pop-up_holder">
                <video preload playsinline controls>
                    <source src="${src}" type="video/${src.slice(src.lastIndexOf(".") + 1)}">
                </video>
                <button type="button" title="Close Video" class="video-pop-up_close"></button>
            </div>
        </div>
    `;

    for (const btnVideo of btnVideos) {
        btnVideo.insertAdjacentElement("afterbegin", document.createElement("span"));
        btnVideo.insertAdjacentHTML("afterend", videoTPL(btnVideo.href));
        
        const videoPopUp = btnVideo.nextElementSibling;
        const video = videoPopUp.getElementsByTagName("video")[0];

        video.addEventListener("loadedmetadata", () => {
            video.width = video.videoWidth;
            video.height = video.videoHeight;
        });

        btnVideo.addEventListener("click", (e) => {
            e.preventDefault();
            videoPopUp.classList.remove("closed");
            setTimeout(() => {
                videoPopUp.classList.add("fade");
                video.play();
            }, 100);
        });
        
        videoPopUp.getElementsByTagName("button")[0].addEventListener("click", () => {
            video.pause();
            videoPopUp.classList.remove("fade");
            videoPopUp.addEventListener("transitionend", () => {
                videoPopUp.classList.add("closed");
            }, {once: true});
        });

        document.addEventListener("visibilitychange", () => {
            video.pause();
        });
    }
})();

